import { Component, Output, EventEmitter, OnInit, Input, ChangeDetectorRef, OnDestroy } from '@angular/core';
import { fadeInOut } from '../../animations/animations';

@Component({
  selector: 'rx-please-wait-circle',
  templateUrl: './please-wait-circle.component.html',
  styleUrls: ['./please-wait-circle.component.scss'],
  animations: [fadeInOut],
})
export class PleaseWaitCircleComponent implements OnInit, OnDestroy {
  /** Main text / title of the modal */
  @Input() public text?: string;

  /** Whether to display the supplier search text */
  @Input() textSupplierSearchEnabled = false;

  /** Text to be displayed before the supplier name */
  @Input() textSupplierSearch = 'Searching';

  /** Text to be displayed when the supplier names rotation ends */
  @Input() textSupplierSearchOver = 'Almost there!';

  /** text to be displayed when the loading time is taking too long / exceeding the time limit */
  @Input() textLoadingTimeExceeded = 'Your search is taking longer than expected.';

  /** text to be displayed for closing modal link	*/
  @Input() textCancel = 'Click here to cancel this search.';

  /** Show cancel link after 50s */
  @Input() isCancelable: boolean;

  /** Show cancel link/button */
  @Input() isCancelVisible = false;

  /** Modal closed */
  @Output() public closed = new EventEmitter<any>();

  /** Array of texts */
  suppliers = ['Booking.com', 'Expedia', 'Hotelbeds'];

  /** Current active index in rotation */
  supplierActiveIndex = 0;

  /** Current active supplier */
  supplierActive = this.suppliers[this.supplierActiveIndex];

  /** Supplier rotation interval var */
  supplierLoopInterval: any;

  /** Reference to the 50second timer to allow loading modal to be closed */
  isCancelableTimer: any;

  constructor(private cd: ChangeDetectorRef) {}

  /** Cancel / close modal */
  public cancel() {
    this.isCancelVisible = false;
    this.closed.emit();
    history.back();
    return false;
  }

  public ngOnInit() {
    if (this.isCancelable) {
      this.isCancelableTimer = setTimeout(() => (this.isCancelVisible = true), 50000);
      this.cd.markForCheck();
    }
    if (!this.isCancelVisible && this.textSupplierSearchEnabled) {
      this.supplierLoopInterval = setInterval(this.setActiveSupplier, 3000);
    }
  }

  /** Rotate suppliers */
  setActiveSupplier = () => {
    if (this.supplierActiveIndex < this.suppliers.length - 1) {
      this.supplierActiveIndex += 1;
      this.supplierActive = this.suppliers[this.supplierActiveIndex];
    } else {
      clearInterval(this.supplierLoopInterval);
      this.supplierActive = this.textSupplierSearchOver;
      this.supplierLoopInterval = false;
    }
    this.cd.markForCheck();
  };

  ngOnDestroy(): void {
    clearTimeout(this.isCancelableTimer);
    clearInterval(this.supplierLoopInterval);
  }
}
